import { useQuery } from "@tanstack/react-query";
import { getSingleNewsApi } from "../../../api/resources.api";
import { SingleNewsResponse } from "../../../types/index";

export const useSingleNews = (id: number | undefined) => {
  return useQuery({
    queryKey: ["news", id],
    queryFn: async () => {
      if (id === undefined) throw new Error("news id is required");
      const res: SingleNewsResponse = await getSingleNewsApi(id);
      if (!res.status || !res.data) throw new Error("Invalid news response");

      return {
        ...res,
        data: {
          ...res.data,
          release_date: res.data.release_date ?? res.data.date_release ?? null,
          date_release: res.data.release_date ?? res.data.date_release ?? null,
        },
      };
    },
    enabled: id !== undefined,
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
